import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { TextTemplate } from '../../services/models/meta-data/text-template.model';
import { TextTemplateService } from '../../services/API/meta-data/text-template.service';
import { PrescriptionNonStandard } from '../../services/models/pharmacy/prescription-non-standard.model';

@Component({
  selector: 'app-prescription-non-standard-modal',
  templateUrl: './prescription-non-standard-modal.component.html',
  styleUrls: ['./prescription-non-standard-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PrescriptionNonStandardModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<PrescriptionNonStandardModalComponent>,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private textTemplateService: TextTemplateService,
  ) { }

  public nonStandardPrescription: PrescriptionNonStandard;
  public model: FormGroup;
  public listTextTemplate: TextTemplate[] = [];
  public quillConfiguration = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'check' }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      [{ 'background': [] }],
    ],
  };

  public isLoading: boolean;
  public readOnly: boolean;

  public selectedTemplateName: string | null = null;

  ngOnInit(): void {
    console.log("Data: ", this.data)
    this.nonStandardPrescription = this.data.prescription;
    this.readOnly = this.data.readOnly;
    this.listTextTemplate = this.data.listTextTemplate;
    this.isLoading = false;
    this.model = this.formBuilder.group({
      formattedText: [{ value: '', disabled: this.readOnly }, Validators.required],
    });
    if (this.nonStandardPrescription) {
      this.populateValues();
    }
  }

  populateValues() {
    this.model.get('formattedText').setValue(this.nonStandardPrescription.formattedText);
    this.selectedTemplateName = (this.nonStandardPrescription as any).textTemplateName || null;
  }

  clickCancel() {
    this.matDialogRef.close();
  }

  close() {
    this.matDialogRef.close();
  }

  onSubmit() {
    if (this.model.invalid) {
      this.alertService.show('Erro', "Preencha todos os campos obrigatórios!", AlertType.error);
      return;
    }


    let newPrescriptionNonStandard: PrescriptionNonStandard = new PrescriptionNonStandard();
    newPrescriptionNonStandard.formattedText = this.model.get('formattedText')?.value;

    (newPrescriptionNonStandard as any).textTemplateName = this.selectedTemplateName;

    this.matDialogRef.close({ newPrescriptionNonStandard: newPrescriptionNonStandard });
  }

  selectTemplateToDescription(textTemplate: TextTemplate) {
    if (textTemplate == null) {
      this.model.get('formattedText')?.setValue(null);
      this.selectedTemplateName = null; // Limpa se desmarcar
      return;
    }
    this.model.get('formattedText')?.setValue(textTemplate.textTemplateContent);
    this.model.get('formattedText')?.markAsDirty();

    this.selectedTemplateName = textTemplate.textTemplateName;
  }
}